// Maps a backend write error into a friendly, human-readable message. The
// SECURITY DEFINER DB functions raise 'not_authorized' when the caller lacks the
// required capability; surface that as a clear permissions message rather than a
// raw SQL error.
export function writeErrorMessage(err: unknown): string {
  const raw = err instanceof Error ? err.message : String(err)
  if (/not_authorized/i.test(raw)) {
    return 'You do not have permission to make this change.'
  }
  if (/no_discrepancy/i.test(raw)) {
    return 'This row is no longer in conflict. Someone may have already resolved it, or the data has been reloaded. Refresh and take another look.'
  }
  if (/already_undone/i.test(raw)) {
    return 'That resolution has already been reversed.'
  }
  if (/resolution_not_found/i.test(raw)) {
    return 'That resolution could not be found, so there is nothing to reverse.'
  }
  if (/ambiguous_mapping/i.test(raw)) {
    return 'There is more than one state this could become, so it cannot be resolved automatically. Set the state on the vehicle directly instead.'
  }
  if (/no_sheet_state/i.test(raw)) {
    return 'This vehicle has no owner-sheet state to compare against.'
  }
  if (/vehicle_not_found/i.test(raw)) {
    return 'That vehicle could not be found.'
  }
  return raw
}
